import {connect} from "react-redux";
import SiteVisit from "./SiteVisit";
import {bindActionCreators} from "redux";
import {allCity} from "../../../../service/locations/action";
import {saveSiteVisit, valetOperationProject} from "../../../../service/Valet/action";
import {getExistingSites} from "../../../../service/Valet/action";

const mapStateToProps = (state) => ({
    allCityDetails:state.locationReducer.allCityDetails,
    siteVisit:state.Valet.siteVisit,
    projectById:state.Valet.projectById,
    existingSiteDetails:state.Valet.existingSiteDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            allCity,
            saveSiteVisit,
            valetOperationProject,
            getExistingSites
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SiteVisit);
